const nl = {
  search: 'zoeken',
  removeX: 'verwijderen',
  closeAllFilters: 'sluit alle filters',
  submit: 'verzenden',
  priceFrom: 'prijs vanaf',
  priceTo: 'prijs tot',
  filtersDescription: 'Alle filters worden geopend als een modaal dialoogvenster',
  outOf: 'van de'
}
const fr = {
  search: 'recherche',
  removeX: 'supprimer',
  closeAllFilters: 'fermer tous les filtres',
  submit: 'envoyer',
  priceFrom: 'prix à partir de',
  priceTo: "prix jusqu'à",
  filtersDescription: 'Tous les filtres s’ouvrent dans une boîte de dialogue modale',
  outOf: 'sur'
}
export const dictionary = lang => (lang === 'fr' ? fr : nl)

export const focusableSelector = `*:is(
  a[href],
  button:not([disabled]),
  textarea:not([disabled]),
  input:not([disabled]):not([type="hidden"]),
  select:not([disabled]),
  [tabindex]:not([tabindex="-1"])
)`
